<template>
  <div class="xiazai">
      <div class="means">
        <div class="means-list">
          <ul class="means-item">
            <li v-for="(item, index) in data" :key="index">
              <div class="means-item-txt">
                <p class="means-item-name">{{ item['fileTitle' + En] }}</p>
                <p class="means-item-date"><img src="https://static.worldaic.com.cn/2024/web/static/images/addr.png" alt="">{{ item.releaseTime }}</p>
              </div>
              <a target="_blank" :href="item.fileUrl" class="download-btn pc">
                {{ $t('downloadFile') }}
              </a>
              <a target="_blank" :href="item.fileUrl" class="download-btn wap">
                {{ $t('downloadFile') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import protal from "@/api/protal";
export default {
  name: 'xiazai',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .xiazai {
    margin-top: -0.33rem;

    .means{
      background: #F6F7F7;
      border-radius: .16rem;

      .means-list{
        display: flex;
        padding: .03rem 0;

        li{
          height: 1.28rem;
          border-bottom: 1px solid RGBA(222, 222, 222, 1);
          display: flex;
          align-items: center;

          .item-title {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 1.23rem;
            font-size: .28rem;
            line-height: 1;
            box-sizing: border-box;
            padding: 0 1em;
            font-weight: bold;
            color: #5238A6;
            background: #DCDCDC;

            &.active {
              background:#5238A6;
              color: #fff;
            }
          }

          .means-item-txt {
            flex: 1;
            overflow: hidden;
            padding-left: .28rem;
          }

          .means-item-name{
            font-size: .22rem;
            line-height: 1;
            color: #595757;
            font-family: sybold;
          }
          .means-item-date{
            font-size: .18rem;
            color:#595757;
            font-family: sybold;
            line-height: .2rem;
            margin-top: .2rem;
            display: flex;

            img {
              width: .2rem;
              height: .2rem;
              margin-right: .06rem;
            }
          }
          .download-btn{
            flex: 0 0 1.08rem;
            height: .44rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #2F9FFA;
            font-size: .2rem;
            color: #fff;
            cursor: pointer;
            text-decoration: none;
            border-radius: .22rem;
            margin: 0 .4rem;

            &:hover {
              opacity: 0.5;
            }
          }
        }
        
        .means-item {
          width: 100%;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .xiazai {
    .means{
      background: #F6F7F7;
      border-radius: .16rem;

      .means-list{
        display: flex;
        padding: .03rem .08rem;

        li{
          height: 1.5rem;
          border-bottom: 1px solid #B4B4B5;
          display: flex;
          align-items: center;

          &:last-child {
            border-bottom: none;
          }

          .item-title {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 1.23rem;
            font-size: .26rem;
            line-height: .36rem;
            box-sizing: border-box;
            padding: 0 1em;
            font-weight: bold;
            color: #5238A6;
            background: #DCDCDC;

            &.active {
              background:#5238A6;
              color: #fff;
            }
          }

          .means-item-txt {
            flex: 1;
            overflow: hidden;
            padding-left: .2rem;
          }

          .means-item-name{
            font-size: .26rem;
            line-height: .36rem;
            color: #595757;
            font-family: sybold;
          }
          .means-item-date{
            font-size: .22rem;
            color:#595757;
            font-family: sybold;
            line-height: 1;
            margin-top: .28rem;
            display: flex;

            img {
              width: .24rem;
              height: .24rem;
              margin-right: .04rem;
            }
          }
          .download-btn{
            flex: 0 0 1.4rem;
            height: .68rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #2F9FFA;
            font-size: .26rem;
            color: #fff;
            cursor: pointer;
            text-decoration: none;
            border-radius: .34rem;
            margin: 0 .2rem;

            &:hover {
              opacity: 0.5;
            }
          }
        }
        
        .means-item {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/wangjie/xiazai.vue